import Lookup from 'src/componentes/select2';

const ConformidadeRevisao = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/ConformidadeRiscoPontoControleRevisaoLookup"
      {...props}
    />
  );
};

export default ConformidadeRevisao;
